"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.success.title': '账户已激活！',
    'activate.success.description': '您的账户已成功激活。您现在可以登录并开始使用IntHub。',
    'activate.success.message': '账户激活成功！',
};
